/**
 * @atlas
 * @kind constant
 * @partOf primitive:shared, primitive:websockets
 * @uses none
 */
import { WS_CHANNELS, type WSChannelFamily } from './channels';

// gloss
export const LIVE_QUERIES = new Set<string>(
  (Object.keys(WS_CHANNELS) as WSChannelFamily[]).filter((family) => WS_CHANNELS[family].type === 'query'),
);
